import extend from 'extend';
import config from 'config';
import I18n from 'i18n-js';
import i18nline from 'i18nline/lib/extensions/i18n_js';
import preactI18nline from 'preact-i18nline/dist/extensions/i18n_js';

i18nline(I18n);
preactI18nline(I18n);

config['langs'].forEach(lang => {
    extend(true, I18n, { translations: require(`../i18n/${lang}.json`) });
});

export { I18n as default };



// WEBPACK FOOTER //
// ./src/app/i18n.js